import PropTypes from 'prop-types'
import React, { Component } from 'react'
import styles from './fixed-right-bottom.styl'

export default class FixedRightBottom extends Component {
  static propTypes = {
    children: PropTypes.any
  }

  render() {
    return (
      <div className={styles.wrap}>
        {this.props.children}
      </div>
    )
  }
}
